import { Nav } from "../components/Nav";
import { Hero } from "../components/landing/Hero";
import { MarqueeStrip } from "../components/landing/MarqueeStrip";
import { SpotlightImage } from "../components/landing/SpotlightImage";
import { Services } from "../components/landing/Services";
import { Marketplaces } from "../components/landing/Marketplaces";
import { Appointment } from "../components/landing/Appointment";
import { Contact } from "../components/landing/Contact";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#050505] text-white min-h-screen">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <SpotlightImage
        src="/assets/nvg-soldiers.jpg"
        alt="Two soldiers with night vision under a starry sky"
        caption="Dark movers — own the night"
        testid="manifesto-image"
      />
      <Services />
      <SpotlightImage
        src="/assets/wizard.jpg"
        alt="Appalachian Guns wizard mascot — forget casting spells, start blasting shells"
        fit="contain"
        testid="appraisals-image"
      />
      <Marketplaces />
      <SpotlightImage
        src="/assets/flag.jpg"
        alt="Betsy Ross flag over Washington crossing the Delaware"
        caption="Since 1776"
        testid="flag-image"
      />
      <Appointment />
      <SpotlightImage
        src="/assets/peace.jpg"
        alt="Peace the old fashion way emblem"
        fit="contain"
        testid="peace-image"
      />
      <Contact />
    </div>
  );
}
